// Register.js
import React, { useState, useEffect } from 'react';
import { useTranslation, Trans } from 'react-i18next';

import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
//import { useData } from '../contexts/DataContext'; 
import { useAppData } from "../hooks/useAppData";
import { useAppStore } from "../hooks/useAppStore"; 
import { useUserData } from "../hooks/useUserData"; // Import Zustand store
import { useUserStore } from "../hooks/useUserStore"; // Import Zustand store

import TurnstileWidget from '../components/Widget/TurnstileWidget';

import PasswordStrengthBar from 'react-password-strength-bar';

import PrivacyPolicy from '../pages/PrivacyPolicy'; // Import PrivacyPolicy component
import TermsAndConditions from '../pages/TermsAndConditions'; // Import TermsAndConditions component

import BwossyLogo from "../components/Layout/BwossyLogo"; 
import logo from '../assets/images/bwossy-logo.svg'; 

// Material-UI icons
import {
  ErrorOutline as ErrorOutlineIcon,
  Visibility,
  VisibilityOff,
} from '@mui/icons-material';

// Material-UI components
import {
  IconButton,
  InputAdornment,
  TextField,
  Button,
  Checkbox, 
  FormControlLabel, 
  FormHelperText,
  FormControl
} from '@mui/material';

const Register = () => {
  const { t } = useTranslation();

  const [website, setWebsite] = useState('');

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const [loading, setLoading] = useState(false);
  const [turnstileTokenStatus, setTurnstileTokenStatus] = useState(''); // Track Turnstile status

  const [nameError, setNameError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [submitError, setSubmitError] = useState('');
  
  const [isPrivacyOverlayVisible, setPrivacyOverlayVisible] = useState(false);
  const [isTermsOverlayVisible, setTermsOverlayVisible] = useState(false);

  const handleOpenPrivacyOverlay = () => setPrivacyOverlayVisible(true);
  const handleClosePrivacyOverlay = () => setPrivacyOverlayVisible(false);
  const handleOpenTermsOverlay = () => setTermsOverlayVisible(true);
  const handleCloseTermsOverlay = () => setTermsOverlayVisible(false);

 
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  /*const { setWordListId, setSoundboardId } = useData(); */// Extracting setWordListId directly from the context
  const { 
      wordListId, setWordListId, 
      soundboardId, setSoundboardId,
      stageWidth, setStageWidth,
      stageHeight, setStageHeight,
      buttonPopovers, setButtonPopovers,
      shapePopovers, setShapePopovers,
      selectedItem, setSelectedItem,
      wordListWidth, setWordListWidth
  } = useAppStore();

  const { registerUser } = useUserData();
  
  const navigate = useNavigate();
  const location = useLocation();
  

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validatePasswordStrength = (password) => {
    // Example validation: password must be at least 8 characters
    return password.length >= 8;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true); // Set loading state to true

    if (website) { return; }
    let hasError = false;

    if (!name.trim()) {
      setNameError(t('errors.nameRequired'));
      hasError = true;
    } else {
      setNameError('');
    }

    if (!email.trim()) {
      setEmailError(t('errors.emailRequired'));
      hasError = true;
    } else if (!validateEmail(email)) {
      setEmailError(t('errors.invalidEmail'));
      hasError = true;
    } else {
      setEmailError('');
    }
      
    
    if (!password.trim()) {
      setPasswordError(t('errors.passwordRequired'));
      hasError = true;
    } else if (!validatePasswordStrength(password)) {
      setPasswordError(t('errors.passwordTooShort'));
      hasError = true;
    } else {
      setPasswordError('');
    }
    
    if (hasError) {
      setLoading(false); // Reset loading state
      return;
    }

    let errors = {};
    if (!name.trim()) errors.name = t('errors.nameRequired');
    if (!email.trim() || !validateEmail(email)) errors.email = t('errors.invalidEmail');
    if (!password.trim() || !validatePasswordStrength(password)) errors.password = t('errors.passwordTooShort');

    if (Object.keys(errors).length) {
      setSubmitError(Object.values(errors).join(', '));
      setLoading(false);
      return;
    }
    
    let consentTracking = false;
    if (window.klaro && typeof window.klaro.getManager === 'function') {
      const manager = window.klaro.getManager();
      consentTracking = manager.getConsent('brevo') || false;
    }

    registerUser.mutate(
      { name, email, password, website, consentTracking },
      {
        onError: (error) => {
          const errorMessage = error?.response?.data?.message || error.message || t("errors.unknownError");
          setSubmitError(errorMessage); // ✅ Pass a string, not an object
          setLoading(false);
        },
        onSettled: () => setLoading(false),
      }
    );
    /*try {
      // Get user consent for email tracking
      let consentTracking = false;
      if (window.klaro && typeof window.klaro.getManager === 'function') {
          const manager = window.klaro.getManager();
          consentTracking = manager.getConsent('brevo') || false;
      }

      
      // Perform registration
      const response = await axios.post(`${baseURL}/api/users/register`, { name, email, password, consentTracking, website });

      if(response && response.data && response.data.accessToken) {
        const { accessToken , wordListId, soundboardId } = response.data; // Ensure that these are included in the response

        localStorage.setItem('userToken', accessToken); // Store the token
        // Redirect or perform additional actions after login success
        setWordListId(wordListId);
        setSoundboardId(soundboardId);

        //navigate('/MainContent');
        navigate(`/verify-email?email=${encodeURIComponent(email)}`);

      } else {
        // Handle cases where the response does not contain the expected data
        setSubmitError(t('register.errors.UnexpectedError'));
      }
     
    } catch (error) {
      if (error.response && error.response.data && error.response.data.message) {
        setSubmitError(error.response?.data?.message || t('errors.unknownError'));
      }
    } finally {
      setLoading(false); 
    }*/
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const emailParam = params.get('email');
    if (emailParam) {
      setEmail(emailParam);
    }
  }, [location]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (email && !validateEmail(email)) {
        setEmailError(t('errors.invalidEmail'));
      } else {
        setEmailError('');
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [email]);


  return (
    <div className="hero-section register">

      <div className='homepage-nav-container'>
        <div className="login-logo-container">
          <a href="./">

            <span className="login-logo-name">
              <Trans i18nKey="common.appNameLogo" components={[<BwossyLogo />]} />
            </span>
            {/*<BwossyLogo />*/}
            {/*<img 
              src={logo} 
              alt="Bwossy logo" 
              className={`login-logo ${isLogoPressed ? 'pressed' : ''}`}
            />*/}
            {/*<span className="login-logo-name">{t('common.appName')}</span>*/}
          </a>
        </div>
    
      </div>

    <div className="content-container">
      <div className="register-container prelogin-container">
        <h1>{t('register.pageTitle')}</h1>
      <div>
        <form onSubmit={handleSubmit} className="register-form" noValidate>
        <div className="website-field">
          <input
            type="text"
            name="website"
            id="website"
            value={website}
            onChange={(e) => setWebsite(e.target.value)}
            autoComplete="off"
          />
        </div>

        {submitError && (
              <div className="general-error-message">
                <ErrorOutlineIcon className="feedback-icon" />
                {submitError}
              </div>
            )}
          <div className="form-group">
            <TextField 
              label={t('common.nameLabel')}
              variant="outlined"
              value={name} 
              onChange={(e) => {
                setName(e.target.value);
                setNameError('');
                setSubmitError('');
              }} 
              error={Boolean(nameError) || Boolean(submitError)}
              helperText={nameError}
              required 
              fullWidth
            />
          </div>
          <div className="form-group">
            <TextField
              label={t('common.emailLabel')}
              variant="outlined"            
              type="email" 
              value={email} 
              onChange={(e) => {
                setEmail(e.target.value);
                setEmailError('');
                setSubmitError('');
              }} 
              error={Boolean(emailError) || Boolean(submitError)}
              helperText={emailError}
              required 
              fullWidth
            />
          </div>
          <div className="form-group input-field">
            <TextField
                label={t('common.passwordLabel')}
                variant="outlined"
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setPasswordError('');
                  setSubmitError('');
                }}
                error={Boolean(passwordError) || Boolean(submitError)}
                helperText={passwordError}
                required
                fullWidth
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end" className="input-adornment">
                      <IconButton
                        onClick={() => setShowPassword(!showPassword)}
                        edge="end"
                        sx={{
                          borderRadius: '50%', // Make the button circular
                        }}
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
          </div>
            {/*<TextField label={t('common.nameLabel')} variant="outlined" value={name} onChange={(e) => setName(e.target.value)} required fullWidth />
            <TextField label={t('common.emailLabel')} variant="outlined" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required fullWidth />
            <TextField
              label={t('common.passwordLabel')}
              variant="outlined"
              type={showPassword ? 'text' : 'password'}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              fullWidth
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />*/}

          <PasswordStrengthBar password={password} />

         {/*} <div className="form-group">
            <FormControl error={!!termsError} component="fieldset">
              <FormControlLabel
                className="no-asterisk"
                control={
                  <Checkbox
                    checked={termsAccepted}
                    onChange={handleCheckboxChange}
                    required
                    color={termsError ? 'error' : 'primary'}
                    aria-invalid={!!termsError}
                  />
                }
                label={
                  <span
                    id="terms-and-conditions-label"
                    style={{
                      color: termsError ? 'red' : 'inherit',
                    }}
                  >
                    {t('register.acceptTermsLabel')}{' '}
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        handleOpenTermsOverlay();
                      }}
                    >
                      {t('register.termsLink')}
                    </a>{' '}
                    {t('common.and')}{' '}
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        handleOpenPrivacyOverlay();
                      }}
                    >
                      {t('register.privacyLink')}
                    </a>
                  </span>
                }
              />
              {termsError && (
                <FormHelperText id="terms-error">
                  {termsError}
                </FormHelperText>
              )}
            </FormControl>
            </div>*/}
          <TurnstileWidget setTurnstileTokenStatus={setTurnstileTokenStatus} />

            <Button
              type="submit"
              variant="contained"
              disabled={loading || turnstileTokenStatus !== "solved"}
            >
                  {loading ? t('common.processingLabel') : t('register.registerLabel')}
            </Button>

            <div className="form-group">
              <p
                id="terms-and-conditions-text"
                style={{
                  color: '#666',
                  fontSize: '0.9rem', // Adjust font size as needed
                  textAlign: 'left', // Center-align the text if necessary
                }}
              >
                {t('register.acceptTermsLabel')}{' '}
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handleOpenTermsOverlay();
                  }}
                >
                  {t('register.termsLink')}
                </a>{' '}
                {t('common.and')}{' '}
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handleOpenPrivacyOverlay();
                  }}
                >
                  {t('register.privacyLink')}
                </a>.
              </p>
            </div>
        </form>
        </div>
      </div>
    </div>

    <PrivacyPolicy
        isVisible={isPrivacyOverlayVisible}
        onClose={handleClosePrivacyOverlay}
      />
    <TermsAndConditions
      isVisible={isTermsOverlayVisible}
      onClose={handleCloseTermsOverlay}
    />
      
  </div>

  
  );
};

export default Register;
